import * as React from "react";
import { SVGProps } from "react";

const ThunderToken = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3500 3500" {...props}>
    <path
      fill="#ffe81c"
      d="M1750 0c966.5 0 1750 783.5 1750 1750s-783.5 1750-1750 1750S0 2716.5 0 1750 783.5 0 1750 0Z"
    />
    <path
      fill="#3f3f3f"
      d="m2887.2 949.3-205.9 668.8h-517.6l-79.9 60.9-280.5 1160.9h-779.5l145.8-433.5 11-42.3-318.9 242.1 441.5-641.7 103.9-346.4H701.8l204-668.8h951.9l361.9-231.8L2072 949.3h815.2z"
    />
    <path
      fill="#ffe81c"
      d="m2609.4 1518 146.5-450.3h-651.6l-179.6 293.8 409.9 154.6 274.8 1.9z"
    />
    <path
      fill="#ffe81c"
      d="m1185.9 2265.6 928.3-703.5-409.9-172.4 25.1-40.7 244.8-383.7 1.9-3.8-703.4 450.7 368.1 192.2-454.9 661.2zm520.7 443.8 207.8-793.7-617.3 480.8L1197 2709h509.6v.4z"
    />
    <path
      fill="#ffe81c"
      d="m1012 1424.7 556.8-355.5-597.1-1.5-138.2 448 397.7 2.3-219.2-93.3z"
    />
  </svg>
);

export default ThunderToken;
